import './comparison_table_component.scss'

import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ['lContainerInner', 'container', 'table', 'floatLeft', 'floatTable', 'scrollLeft', 'scrollbarContainer', 'scrollbarHandler']
  FIRST_COLUMN_LEFT_PADDING = 36
  SCROLL_HANDLER_WIDTH = 84

  connect () {
    this.updateFirstColumnPadding()
    this.scrollbarContainerTarget.onmousedown = this.touchStart.bind(this)
    this.scrollbarContainerTarget.ontouchstart = this.touchStart.bind(this)
  }

  updateFirstColumnPadding () {
    const elements = this.tableTarget.querySelectorAll('th:first-child, td:first-child')
    elements.forEach((element) => {
      element.style.paddingLeft = `${this.offsetLeft}px`
    })
  }

  touchStart (e) {
    if (e.target !== this.scrollbarHandlerTarget) {
      return
    }

    this.scrollbarHandlerTarget.moving = true

    if (e.clientX) {
      this.scrollbarHandlerTarget.oldX = e.clientX
    } else {
      this.scrollbarHandlerTarget.oldX = e.touches[0].clientX
      this.scrollbarHandlerTarget.oldLeft = parseFloat(window.getComputedStyle(this.scrollbarHandlerTarget).getPropertyValue('left'))

      document.addEventListener('touchmove', this.touchMove.bind(this), { passive: false })
      this.scrollbarHandlerTarget.onmouseup = this.touchEnd.bind(this)
      this.scrollbarHandlerTarget.ontouchend = this.touchEnd.bind(this)
    }
  }

  touchMove (event) {
    if (!this.scrollbarHandlerTarget.moving) {
      return
    }
    if (event.clientX) {
      this.scrollbarHandlerTarget.distX = event.clientX - this.scrollbarHandlerTarget.oldX
    } else {
      this.scrollbarHandlerTarget.distX = event.touches[0].clientX - this.scrollbarHandlerTarget.oldX
    }
    const position = this.scrollbarHandlerTarget.oldLeft + this.scrollbarHandlerTarget.distX
    if (position <= 0) {
      this.scrollbarHandlerTarget.style.left = '0px'
    } else if (position >= this.scrollbarContainerWidth - this.SCROLL_HANDLER_WIDTH) {
      this.scrollbarHandlerTarget.style.left = this.scrollbarContainerWidth - this.SCROLL_HANDLER_WIDTH + 'px'
    } else {
      this.scrollbarHandlerTarget.style.left = this.scrollbarHandlerTarget.oldLeft + this.scrollbarHandlerTarget.distX + 'px'
    }
    this.scrollTableTo(position / (this.scrollbarContainerWidth - this.SCROLL_HANDLER_WIDTH))
  }

  touchEnd () {
    this.scrollbarHandlerTarget.moving = false
  }

  scrollTableTo (percentage) {
    this.containerTarget.scrollLeft = this.tableWidth * percentage
  }

  scrollScrollHandlerTo (percentage) {
    this.scrollbarHandlerTarget.style.left = `${(this.scrollbarContainerWidth - this.SCROLL_HANDLER_WIDTH) * percentage}px`
  }

  containerScroll () {
    if (this.containerTarget.scrollLeft >= this.offsetLeft - this.FIRST_COLUMN_LEFT_PADDING) {
      this.showFloatTableAndLeftNavigation()
    } else {
      this.hideFloatTableAndLeftNavigation()
    }

    if (!this.scrollbarHandlerTarget.moving) { this.scrollScrollHandlerTo(this.containerTarget.scrollLeft / (this.tableWidth - this.windowWidth)) }
  }

  showFloatTableAndLeftNavigation () {
    this.floatLeftTarget.classList.add('comparison_table-float-left--active')
  }

  hideFloatTableAndLeftNavigation () {
    this.floatLeftTarget.classList.remove('comparison_table-float-left--active')
  }

  scrollRight () {
    this.containerTarget.scrollLeft += 300
    this.containerScroll()
  }

  scrollLeft () {
    this.containerTarget.scrollLeft -= 300
    this.containerScroll()
  }

  showFloatTable () {
    this.floatTableTarget.classList.add('comparison_table-float-table--active')
  }

  hideFloatTable () {
    this.floatTableTarget.classList.remove('comparison_table-float-table--active')
  }

  showLeftScrollArrow () {
    this.scrollLeftTarget.classList.add('comparison_table-scroll-left--active')
  }

  hideLeftScrollArrow () {
    this.scrollLeftTarget.classList.remove('comparison_table-scroll-left--active')
  }

  get offsetLeft () {
    return this.lContainerInnerTarget.offsetLeft
  }

  get windowWidth () {
    return window.innerWidth
  }

  get tableWidth () {
    return this.tableTarget.clientWidth
  }

  get scrollbarContainerWidth () {
    return this.scrollbarContainerTarget.clientWidth
  }
}
